import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GroupContext } from './GroupContext.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getValueItem = function getValueItem(e) {
  var target = e.target,
      currentTarget = e.currentTarget;

  if (target) {
    var value = target.value;
    return value;
  }

  if (currentTarget) {
    var _value = currentTarget.value;
    return _value;
  }

  return e;
};

var toggleItemValue = function toggleItemValue(array, e) {
  var newvalue = getValueItem(e);
  var res = array;
  var index = array.indexOf(newvalue);

  if (index === -1) {
    res.push(newvalue);
  } else {
    res.splice(index, 1);
  }

  return res;
};

var Provider = GroupContext.Provider;
/** deprecated use CheckableGroup instead */

var Group = /*#__PURE__*/function (_Component) {
  _inherits(Group, _Component);

  var _super = _createSuper(Group);

  function Group(props) {
    var _this;

    _classCallCheck(this, Group);

    _this = _super.call(this, props);
    var activeValue = props.activeValue,
        disabled = props.disabled;
    _this.state = {
      activeValue: activeValue,
      disabled: disabled,
      prevValue: null,
      onChange: _this.handleChange.bind(_assertThisInitialized(_this))
    };
    return _this;
  }

  _createClass(Group, [{
    key: "handleChange",
    value: function handleChange(e) {
      var _this$props = this.props,
          multiple = _this$props.multiple,
          onChange = _this$props.onChange;
      var activeValue = this.state.activeValue;
      var value = getValueItem(e);
      var newValue;

      if (multiple) {
        newValue = toggleItemValue(activeValue || [], value);
      } else if (activeValue !== value) {
        // default behaviour it will be toggle the active value
        newValue = value;
      }

      this.setState({
        activeValue: newValue
      });

      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      if (onChange) onChange.apply(void 0, [newValue].concat(rest));
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(Provider, {
        value: this.state
      }, children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, _ref) {
      var prevValue = _ref.prevValue;
      if (nextProps.activeValue === prevValue) return null;
      return {
        activeValue: nextProps.activeValue,
        prevValue: nextProps.activeValue
      };
    }
  }]);

  return Group;
}(Component);

Group.defaultProps = {
  multiple: false
};
Group.propTypes = {
  children: PropTypes.array,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  activeValue: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  disabled: PropTypes.bool
};

export default Group;
//# sourceMappingURL=Group.js.map
